// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"7a4f99ec","496":"8d8889c6","647":"c9a7de18"}[chunkId] + ".chunk.js";
};